var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import { hideMenuProvider } from '../../utilities/picker.tools';
import { currentDateKey, dateToKey, dateToSpecifiedFormat, keyToDate, parseAndValidateDate, } from './date-picker-calculations';
import '../shared/month-view/month-view.lit';
import '../shared/calendar/sds-calendar.lit';
import { translate } from '../../utilities/translate';
import styles from '../sds-date-picker.lit.scss';
import { sdsCustomElement } from '../../utilities/custom-components';
import './sds-date-entry-input.lit';
/**
 * `sds-date-picker` is a web component that allows users to select a date using an interactive calendar interface.
 * It provides a user-friendly way to choose a single date and offers features such as localization, placeholders,
 * and optional clear functionality.
 *
 * ### Features:
 * - **Clear button** to reset the selected date (configurable).
 * - **Locale support** to format the date according to regional settings.
 * - **Placeholder text** to guide users when no date is selected.
 * - **Responsive calendar view**, adapting to different screen sizes.
 * - Emits events on date selection for easy integration with other components or logic.
 */
let SdsDatePicker = (() => {
    var _SdsDatePicker_placeholder_accessor_storage, _SdsDatePicker_hint_accessor_storage, _SdsDatePicker_disabled_accessor_storage, _SdsDatePicker_invalid_accessor_storage, _SdsDatePicker_readonly_accessor_storage, _SdsDatePicker_errorMessage_accessor_storage, _SdsDatePicker_selectedDate_accessor_storage, _SdsDatePicker_locale_accessor_storage, _SdsDatePicker__internalValue_accessor_storage, _SdsDatePicker_currentDay_accessor_storage, _SdsDatePicker_hasClear_accessor_storage, _SdsDatePicker__contextMenu_accessor_storage, _SdsDatePicker__inputDate_accessor_storage, _SdsDatePicker__dateEntryInput_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-date-picker')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _placeholder_decorators;
    let _placeholder_initializers = [];
    let _placeholder_extraInitializers = [];
    let _hint_decorators;
    let _hint_initializers = [];
    let _hint_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _invalid_decorators;
    let _invalid_initializers = [];
    let _invalid_extraInitializers = [];
    let _readonly_decorators;
    let _readonly_initializers = [];
    let _readonly_extraInitializers = [];
    let _errorMessage_decorators;
    let _errorMessage_initializers = [];
    let _errorMessage_extraInitializers = [];
    let _selectedDate_decorators;
    let _selectedDate_initializers = [];
    let _selectedDate_extraInitializers = [];
    let _locale_decorators;
    let _locale_initializers = [];
    let _locale_extraInitializers = [];
    let __internalValue_decorators;
    let __internalValue_initializers = [];
    let __internalValue_extraInitializers = [];
    let _currentDay_decorators;
    let _currentDay_initializers = [];
    let _currentDay_extraInitializers = [];
    let _hasClear_decorators;
    let _hasClear_initializers = [];
    let _hasClear_extraInitializers = [];
    let __contextMenu_decorators;
    let __contextMenu_initializers = [];
    let __contextMenu_extraInitializers = [];
    let __inputDate_decorators;
    let __inputDate_initializers = [];
    let __inputDate_extraInitializers = [];
    let __dateEntryInput_decorators;
    let __dateEntryInput_initializers = [];
    let __dateEntryInput_extraInitializers = [];
    var SdsDatePicker = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsDatePicker_placeholder_accessor_storage.set(this, __runInitializers(this, _placeholder_initializers, 'sds.date_picker.placeholder'));
            _SdsDatePicker_hint_accessor_storage.set(this, (__runInitializers(this, _placeholder_extraInitializers), __runInitializers(this, _hint_initializers, '')));
            _SdsDatePicker_disabled_accessor_storage.set(this, (__runInitializers(this, _hint_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsDatePicker_invalid_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _invalid_initializers, false)));
            _SdsDatePicker_readonly_accessor_storage.set(this, (__runInitializers(this, _invalid_extraInitializers), __runInitializers(this, _readonly_initializers, false)));
            _SdsDatePicker_errorMessage_accessor_storage.set(this, (__runInitializers(this, _readonly_extraInitializers), __runInitializers(this, _errorMessage_initializers, '')));
            _SdsDatePicker_selectedDate_accessor_storage.set(this, (__runInitializers(this, _errorMessage_extraInitializers), __runInitializers(this, _selectedDate_initializers, void 0)));
            _SdsDatePicker_locale_accessor_storage.set(this, (__runInitializers(this, _selectedDate_extraInitializers), __runInitializers(this, _locale_initializers, navigator.language)));
            _SdsDatePicker__internalValue_accessor_storage.set(this, (__runInitializers(this, _locale_extraInitializers), __runInitializers(this, __internalValue_initializers, void 0)));
            _SdsDatePicker_currentDay_accessor_storage.set(this, (__runInitializers(this, __internalValue_extraInitializers), __runInitializers(this, _currentDay_initializers, currentDateKey())));
            _SdsDatePicker_hasClear_accessor_storage.set(this, (__runInitializers(this, _currentDay_extraInitializers), __runInitializers(this, _hasClear_initializers, true)));
            _SdsDatePicker__contextMenu_accessor_storage.set(this, (__runInitializers(this, _hasClear_extraInitializers), __runInitializers(this, __contextMenu_initializers, void 0)));
            _SdsDatePicker__inputDate_accessor_storage.set(this, (__runInitializers(this, __contextMenu_extraInitializers), __runInitializers(this, __inputDate_initializers, void 0)));
            _SdsDatePicker__dateEntryInput_accessor_storage.set(this, (__runInitializers(this, __inputDate_extraInitializers), __runInitializers(this, __dateEntryInput_initializers, void 0)));
            this._sdsCalendar = __runInitializers(this, __dateEntryInput_extraInitializers);
            this.hideMenu = (event) => {
                var _a, _b;
                hideMenuProvider(this)(event);
                if (!((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened)) {
                    (_b = this._inputDate) === null || _b === void 0 ? void 0 : _b.handleCalendarClosed();
                }
            };
            this.handleDateEntryInputChange = (event) => {
                // Update the selected date and dispatch change event
                const { selectedDate } = event.detail;
                if (selectedDate) {
                    this._internalValue = keyToDate(selectedDate);
                    // Update calendar page if calendar is open
                    this.updateCalendarPage();
                }
                else {
                    this._internalValue = undefined;
                }
                this.dispatchChange(this._internalValue);
            };
            this.handleDateEntryInput = (event) => {
                // Only update the selected date, input event is already dispatched by child
                const { selectedDate } = event.detail;
                if (selectedDate) {
                    this._internalValue = keyToDate(selectedDate);
                    // Update calendar page if calendar is open
                    this.updateCalendarPage();
                }
                else {
                    this._internalValue = undefined;
                }
            };
            this.handleDateEntryCleared = () => {
                this._internalValue = undefined;
                this.dispatchChange(undefined);
                this.closeCalendar();
            };
            this.handleCleared = () => {
                var _a;
                this._inputDate.focused = Boolean((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened);
                this.updateSelectedDate();
            };
            this.handleDateInputCursorChange = (event) => {
                var _a, _b, _c;
                const cursorPosition = event.detail;
                if (cursorPosition === 'OnYear') {
                    (_a = this._sdsCalendar) === null || _a === void 0 ? void 0 : _a.navigateTo('SelectYear');
                }
                else if (cursorPosition === 'OnMonth') {
                    (_b = this._sdsCalendar) === null || _b === void 0 ? void 0 : _b.navigateTo('SelectMonth');
                }
                else if (cursorPosition === 'OnDay') {
                    (_c = this._sdsCalendar) === null || _c === void 0 ? void 0 : _c.navigateTo('SelectDate');
                }
            };
            this.handleDatePicked = (event) => {
                var _a, _b;
                this.updateSelectedDate(event.detail.date);
                const [year, month] = event.detail.date;
                (_a = this._sdsCalendar) === null || _a === void 0 ? void 0 : _a.setPageIndex(year, month);
                this.closeCalendar();
                // Keep focus on input fields after selecting a date from calendar
                if (!this.readonly) {
                    (_b = this._dateEntryInput) === null || _b === void 0 ? void 0 : _b.focus();
                }
            };
            this.handleMonthSelect = (event) => {
                var _a, _b;
                const [year, month] = event.detail.month;
                (_a = this._sdsCalendar) === null || _a === void 0 ? void 0 : _a.setMonthStateMapper(([keyYear, keyMonth]) => keyYear === year && keyMonth === month ? 'selected' : 'none');
                (_b = this._sdsCalendar) === null || _b === void 0 ? void 0 : _b.setYearStateMapper(keyYear => (keyYear === year ? 'selected' : 'none'));
            };
            this.handleYearSelect = (event) => {
                var _a;
                (_a = this._sdsCalendar) === null || _a === void 0 ? void 0 : _a.setYearStateMapper(keyYear => keyYear === event.detail.year ? 'selected' : 'none');
            };
            this.handleCalendarClick = (event) => {
                // Prevent calendar clicks from bubbling up and triggering the date picker's click handler
                event.stopPropagation();
            };
            this.openCalendar = () => {
                var _a, _b, _c, _d, _e;
                if (this.disabled) {
                    return;
                }
                // Toggle: if already open, close it and blur the input
                if ((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened) {
                    this.closeCalendar();
                    // Blur the date entry input when closing calendar
                    if (!this.readonly) {
                        (_b = this._dateEntryInput) === null || _b === void 0 ? void 0 : _b.blur();
                    }
                    return;
                }
                this.resetPage();
                let trigger = null;
                if (this.readonly) {
                    // For readonly mode, use the input-date element
                    this._inputDate.focused = true;
                    trigger = this._inputDate.getInput();
                    this._inputDate.handleCalendarOpened();
                }
                else {
                    // For normal mode, use the date-entry-input container
                    trigger = (_d = (_c = this._dateEntryInput) === null || _c === void 0 ? void 0 : _c.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector('.sds-date-entry-input');
                }
                if (trigger) {
                    (_e = this._contextMenu) === null || _e === void 0 ? void 0 : _e.show(trigger);
                    this.setMappers();
                }
            };
        }
        /**
         * Sets the placeholder text, providing a hint when no date is selected.
         * This helps guide users to understand the expected input format or purpose of the date picker selection.
         *
         * @attr {string} placeholder - Placeholder text for the date picker input.
         */
        get placeholder() { return __classPrivateFieldGet(this, _SdsDatePicker_placeholder_accessor_storage, "f"); }
        set placeholder(value) { __classPrivateFieldSet(this, _SdsDatePicker_placeholder_accessor_storage, value, "f"); }
        /**
         * Hint for this date picker.
         * @attr
         */
        get hint() { return __classPrivateFieldGet(this, _SdsDatePicker_hint_accessor_storage, "f"); }
        set hint(value) { __classPrivateFieldSet(this, _SdsDatePicker_hint_accessor_storage, value, "f"); }
        /**
         * True if this date picker is disabled.
         * @attr
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsDatePicker_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsDatePicker_disabled_accessor_storage, value, "f"); }
        /**
         * True if this date picker is invalid.
         * @attr
         */
        get invalid() { return __classPrivateFieldGet(this, _SdsDatePicker_invalid_accessor_storage, "f"); }
        set invalid(value) { __classPrivateFieldSet(this, _SdsDatePicker_invalid_accessor_storage, value, "f"); }
        /**
         * True if this date picker is readonly.
         * @attr
         */
        get readonly() { return __classPrivateFieldGet(this, _SdsDatePicker_readonly_accessor_storage, "f"); }
        set readonly(value) { __classPrivateFieldSet(this, _SdsDatePicker_readonly_accessor_storage, value, "f"); }
        /**
         * The error message of this date picker, in case there is a validation error.
         * @attr
         */
        get errorMessage() { return __classPrivateFieldGet(this, _SdsDatePicker_errorMessage_accessor_storage, "f"); }
        set errorMessage(value) { __classPrivateFieldSet(this, _SdsDatePicker_errorMessage_accessor_storage, value, "f"); }
        /** {year}/{month}/{day} format */
        get selectedDate() { return __classPrivateFieldGet(this, _SdsDatePicker_selectedDate_accessor_storage, "f"); }
        set selectedDate(value) { __classPrivateFieldSet(this, _SdsDatePicker_selectedDate_accessor_storage, value, "f"); }
        /**
         * The locale to use for date formatting.
         * This affects how dates are displayed and formatted.
         *
         * Examples:
         * - 'en-US' (US English)
         * - 'de-DE' (German)
         * - 'fr-FR' (French)
         * - 'ja-JP' (Japanese)
         *
         * Defaults to the browser's locale (navigator.language)
         *
         * @attr
         */
        get locale() { return __classPrivateFieldGet(this, _SdsDatePicker_locale_accessor_storage, "f"); }
        set locale(value) { __classPrivateFieldSet(this, _SdsDatePicker_locale_accessor_storage, value, "f"); }
        /** Internal storage for the selected date as LocalDate array */
        get _internalValue() { return __classPrivateFieldGet(this, _SdsDatePicker__internalValue_accessor_storage, "f"); }
        set _internalValue(value) { __classPrivateFieldSet(this, _SdsDatePicker__internalValue_accessor_storage, value, "f"); }
        /**
         * The selected date value. Supports multiple input formats:
         * - ISO string format (YYYY-MM-DD) - HTML5 standard
         * - Legacy string format (YYYY/MM/DD) - backward compatibility
         * - Any valid date string parseable by Date constructor
         * - Timestamp (number) - milliseconds or seconds since Unix epoch
         * - Date object
         *
         * Always returns ISO format string (YYYY-MM-DD) when getting the value.
         *
         * @attr {DateValue} value - Any value that new Date() can parse
         * @example
         * // String formats
         * <sds-date-picker value="2024-03-15"></sds-date-picker>
         * <sds-date-picker value="2024/03/15"></sds-date-picker>
         * <sds-date-picker value="March 15, 2024"></sds-date-picker>
         * <sds-date-picker value="Mon Sep 08 2025 14:32:42 GMT+0400"></sds-date-picker>
         *
         * // Timestamp
         * <sds-date-picker value="1710460800000"></sds-date-picker>
         *
         * // Programmatic usage
         * datePicker.value = new Date();
         * datePicker.value = 1710460800000;
         * datePicker.value = "March 15, 2024";
         */
        get value() {
            if (!this._internalValue)
                return undefined;
            const [year, month, day] = this._internalValue;
            return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        }
        set value(val) {
            // Prevent value changes when disabled
            if (this.disabled) {
                return;
            }
            if (val === undefined || val === null) {
                this._internalValue = undefined;
            }
            else {
                this._internalValue = parseAndValidateDate(val);
            }
        }
        /**
         * Internal getter for backward compatibility - returns the LocalDate array format
         */
        get valueAsLocalDate() {
            return this._internalValue;
        }
        /**
         * Gets/sets the selected date as a Date object (HTML5 input[type="date"] compatible).
         * @example
         * datePicker.valueAsDate = new Date('2024-03-15');
         * console.log(datePicker.valueAsDate); // Date object
         */
        get valueAsDate() {
            if (!this._internalValue)
                return null;
            const [year, month, day] = this._internalValue;
            // Use setFullYear to avoid JavaScript's 0-99 year interpretation
            const date = new Date();
            date.setFullYear(year, month - 1, day);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        set valueAsDate(value) {
            // Prevent value changes when disabled
            if (this.disabled) {
                return;
            }
            if (value === null) {
                this._internalValue = undefined;
            }
            else {
                const year = value.getFullYear();
                const month = value.getMonth() + 1;
                const day = value.getDate();
                this._internalValue = [year, month, day];
            }
        }
        /**
         * Gets/sets the selected date as milliseconds since Unix epoch (HTML5 input[type="date"] compatible).
         * @example
         * datePicker.valueAsNumber = Date.parse('2024-03-15');
         * console.log(datePicker.valueAsNumber); // 1710460800000
         */
        get valueAsNumber() {
            const date = this.valueAsDate;
            return date ? date.getTime() : NaN;
        }
        set valueAsNumber(value) {
            // Prevent value changes when disabled
            if (this.disabled) {
                return;
            }
            if (isNaN(value)) {
                this.valueAsDate = null;
            }
            else {
                this.valueAsDate = new Date(value);
            }
        }
        get currentDay() { return __classPrivateFieldGet(this, _SdsDatePicker_currentDay_accessor_storage, "f"); }
        set currentDay(value) { __classPrivateFieldSet(this, _SdsDatePicker_currentDay_accessor_storage, value, "f"); }
        /**
         * Controls whether the date picker displays a "clear" button, allowing users to remove the selected date.
         * When enabled, the clear button provides an easy way to reset the input field to an empty state.
         *
         * - If `true`, the clear button is visible within the picker.
         * - If `false`, the clear button is hidden, preventing users from clearing the date input.
         *
         * Defaults to `true`.
         *
         * @attr {boolean} has-clear - Whether the picker shows a clear button.
         */
        get hasClear() { return __classPrivateFieldGet(this, _SdsDatePicker_hasClear_accessor_storage, "f"); }
        set hasClear(value) { __classPrivateFieldSet(this, _SdsDatePicker_hasClear_accessor_storage, value, "f"); }
        get _contextMenu() { return __classPrivateFieldGet(this, _SdsDatePicker__contextMenu_accessor_storage, "f"); }
        set _contextMenu(value) { __classPrivateFieldSet(this, _SdsDatePicker__contextMenu_accessor_storage, value, "f"); }
        get _inputDate() { return __classPrivateFieldGet(this, _SdsDatePicker__inputDate_accessor_storage, "f"); }
        set _inputDate(value) { __classPrivateFieldSet(this, _SdsDatePicker__inputDate_accessor_storage, value, "f"); }
        get _dateEntryInput() { return __classPrivateFieldGet(this, _SdsDatePicker__dateEntryInput_accessor_storage, "f"); }
        set _dateEntryInput(value) { __classPrivateFieldSet(this, _SdsDatePicker__dateEntryInput_accessor_storage, value, "f"); }
        render() {
            if (this.readonly) {
                return html `
                <sds-input-date
                    id="input-date"
                    placeholder="${translate(this.placeholder)}"
                    ?hasclear="${this.hasClear}"
                    ?disabled="${this.disabled}"
                    hint="${this.hint}"
                    format-enforced
                    error-message="${this.errorMessage}"
                    ?invalid="${this.invalid}"
                    @click="${this.openCalendar}"
                    @sds.input-date.cleared="${this.handleCleared}"
                    @sds.input-date.date-cursor-change="${this.handleDateInputCursorChange}"
                ></sds-input-date>
                <sds-context-menu>
                    <sds-calendar
                        currentDay="${this.currentDay}"
                        @sds.calendar.select="${this.handleDatePicked}"
                        @sds.calendar.month.select="${this.handleMonthSelect}"
                        @sds.calendar.year.select="${this.handleYearSelect}"
                        tabindex="0"
                    >
                    </sds-calendar>
                </sds-context-menu>
            `;
            }
            return html `
            <sds-date-entry-input
                value="${this._internalValue ? dateToKey(...this._internalValue) : ''}"
                ?disabled="${this.disabled}"
                ?invalid="${this.invalid}"
                ?has-clear="${this.hasClear}"
                .locale="${this.locale}"
                error-message="${this.errorMessage}"
                hint="${this.hint}"
                @sds.date-picker.changed="${this.handleDateEntryInputChange}"
                @sds.date-picker.input="${this.handleDateEntryInput}"
                @sds.date-entry-input.calendar-clicked="${this.openCalendar}"
                @sds.date.cleared="${this.handleDateEntryCleared}"
            ></sds-date-entry-input>
            <sds-context-menu>
                <sds-calendar
                    currentDay="${this.currentDay}"
                    selectedDate="${this._internalValue ? dateToKey(...this._internalValue) : ''}"
                    @sds.calendar.select="${this.handleDatePicked}"
                    @sds.calendar.month.select="${this.handleMonthSelect}"
                    @sds.calendar.year.select="${this.handleYearSelect}"
                    @click="${this.handleCalendarClick}"
                    tabindex="0"
                >
                </sds-calendar>
            </sds-context-menu>
        `;
        }
        willUpdate(_changedProperties) {
            // Keep value and selectedDate properties in sync for backward compatibility
            if (_changedProperties.has('_internalValue') && !_changedProperties.has('selectedDate')) {
                this.selectedDate = this._internalValue;
            }
            else if (_changedProperties.has('selectedDate') &&
                !_changedProperties.has('_internalValue')) {
                this._internalValue = this.selectedDate;
            }
            if (_changedProperties.has('_internalValue') || _changedProperties.has('selectedDate')) {
                this.setMappers();
            }
            if (_changedProperties.has('hasClear') && this._inputDate) {
                this._inputDate.hasClear = this.hasClear;
            }
        }
        updated(_changedProperties) {
            if (_changedProperties.has('_internalValue') || _changedProperties.has('selectedDate')) {
                const currentDate = this._internalValue || this.selectedDate;
                if (currentDate) {
                    this.updateInput(currentDate);
                }
                else {
                    this.updateInput();
                }
            }
        }
        async firstUpdated(_changedProperties) {
            this.initCmContentContainer();
            await this.updateComplete;
            this.updatePageIndex();
            if (_changedProperties.has('hasClear') && this._inputDate) {
                this._inputDate.hasClear = this.hasClear;
            }
        }
        initCmContentContainer() {
            var _a;
            const sdsCalendar = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('sds-calendar');
            if (sdsCalendar) {
                this._sdsCalendar = sdsCalendar;
            }
        }
        connectedCallback() {
            super.connectedCallback();
            document.addEventListener('mouseup', this.hideMenu);
        }
        disconnectedCallback() {
            document.removeEventListener('mouseup', this.hideMenu);
            this.closeCalendar();
            super.disconnectedCallback();
        }
        resetPage() {
            var _a;
            (_a = this._sdsCalendar) === null || _a === void 0 ? void 0 : _a.navigateTo('SelectDate');
            this.updatePageIndex();
        }
        updatePageIndex() {
            var _a;
            if (this.selectedDate || this.currentDay) {
                const [year, month] = this.selectedDate
                    ? this.selectedDate
                    : keyToDate(this.currentDay);
                (_a = this._sdsCalendar) === null || _a === void 0 ? void 0 : _a.setPageIndex(year, month);
            }
        }
        updateCalendarPage() {
            var _a, _b;
            // Only update calendar page if calendar is currently open and we have a valid date
            if (((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened) && this._internalValue) {
                const [year, month] = this._internalValue;
                (_b = this._sdsCalendar) === null || _b === void 0 ? void 0 : _b.setPageIndex(year, month);
            }
        }
        closeCalendar() {
            var _a;
            if ((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened) {
                this._contextMenu.hide();
            }
        }
        dispatchChange(date) {
            const key = date ? dateToKey(...date) : undefined;
            const change = new CustomEvent(SdsDatePicker.CHANGE_EVENT, {
                detail: { selectedDate: key },
            });
            this.dispatchEvent(change);
            const nativeChange = new CustomEvent(SdsDatePicker.NATIVE_CHANGE_EVENT, {
                detail: { selectedDate: key },
            });
            this.dispatchEvent(nativeChange);
        }
        updateSelectedDate(date) {
            this.selectedDate = date;
            this.updatePageIndex();
            this.dispatchChange(date);
            this.setMappers();
        }
        setMappers() {
            var _a, _b, _c, _d, _e, _f;
            if (this.selectedDate) {
                const [year, month, day] = this.selectedDate;
                (_a = this._sdsCalendar) === null || _a === void 0 ? void 0 : _a.setDateStateMapper(([keyYear, keyMonth, keyDay]) => keyYear === year && keyMonth === month && keyDay === day ? 'selected' : 'none');
                (_b = this._sdsCalendar) === null || _b === void 0 ? void 0 : _b.setMonthStateMapper(([keyYear, keyMonth]) => keyYear === year && keyMonth === month ? 'selected' : 'none');
                (_c = this._sdsCalendar) === null || _c === void 0 ? void 0 : _c.setYearStateMapper(keyYear => keyYear === year ? 'selected' : 'none');
            }
            else {
                (_d = this._sdsCalendar) === null || _d === void 0 ? void 0 : _d.setDateStateMapper(() => 'none');
                (_e = this._sdsCalendar) === null || _e === void 0 ? void 0 : _e.setMonthStateMapper(() => 'none');
                (_f = this._sdsCalendar) === null || _f === void 0 ? void 0 : _f.setYearStateMapper(() => 'none');
            }
        }
        updateInput(date) {
            var _a;
            if (this.readonly) {
                this._inputDate.dateSelected(date ? dateToSpecifiedFormat(date, this._inputDate.format) : '');
            }
            else {
                const dateEntryInput = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('sds-date-entry-input');
                if (dateEntryInput) {
                    // Use the public method to set the internal value directly
                    dateEntryInput.setInternalValue(date);
                }
            }
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        focus() {
            var _a;
            if (!this.readonly && !this.disabled) {
                (_a = this._dateEntryInput) === null || _a === void 0 ? void 0 : _a.focus();
            }
        }
        blur() {
            var _a;
            if (!this.readonly) {
                (_a = this._dateEntryInput) === null || _a === void 0 ? void 0 : _a.blur();
            }
        }
        click() {
            var _a, _b;
            if (!this.readonly && !this.disabled) {
                (_a = this._dateEntryInput) === null || _a === void 0 ? void 0 : _a.focus();
                (_b = this._dateEntryInput) === null || _b === void 0 ? void 0 : _b.click();
            }
        }
    };
    _SdsDatePicker_placeholder_accessor_storage = new WeakMap();
    _SdsDatePicker_hint_accessor_storage = new WeakMap();
    _SdsDatePicker_disabled_accessor_storage = new WeakMap();
    _SdsDatePicker_invalid_accessor_storage = new WeakMap();
    _SdsDatePicker_readonly_accessor_storage = new WeakMap();
    _SdsDatePicker_errorMessage_accessor_storage = new WeakMap();
    _SdsDatePicker_selectedDate_accessor_storage = new WeakMap();
    _SdsDatePicker_locale_accessor_storage = new WeakMap();
    _SdsDatePicker__internalValue_accessor_storage = new WeakMap();
    _SdsDatePicker_currentDay_accessor_storage = new WeakMap();
    _SdsDatePicker_hasClear_accessor_storage = new WeakMap();
    _SdsDatePicker__contextMenu_accessor_storage = new WeakMap();
    _SdsDatePicker__inputDate_accessor_storage = new WeakMap();
    _SdsDatePicker__dateEntryInput_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsDatePicker");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _placeholder_decorators = [property({ type: String })];
        _hint_decorators = [property({ type: String })];
        _disabled_decorators = [property({ type: Boolean })];
        _invalid_decorators = [property({ type: Boolean })];
        _readonly_decorators = [property({ type: Boolean })];
        _errorMessage_decorators = [property({ type: String, attribute: 'error-message' })];
        _selectedDate_decorators = [property({
                type: String,
                converter: keyToDate,
                attribute: 'selected-date',
            })];
        _locale_decorators = [property({ type: String })];
        __internalValue_decorators = [property({
                reflect: true,
                converter: {
                    fromAttribute: (value) => {
                        if (!value)
                            return undefined;
                        return parseAndValidateDate(value);
                    },
                    toAttribute: (value) => {
                        if (!value)
                            return '';
                        return dateToKey(...value);
                    },
                },
                attribute: 'value',
            })];
        _currentDay_decorators = [property({ attribute: 'current-date' })];
        _hasClear_decorators = [property({ attribute: 'has-clear', type: Boolean, reflect: true })];
        __contextMenu_decorators = [query('sds-context-menu')];
        __inputDate_decorators = [query('#input-date')];
        __dateEntryInput_decorators = [query('sds-date-entry-input')];
        __esDecorate(_classThis, null, _placeholder_decorators, { kind: "accessor", name: "placeholder", static: false, private: false, access: { has: obj => "placeholder" in obj, get: obj => obj.placeholder, set: (obj, value) => { obj.placeholder = value; } }, metadata: _metadata }, _placeholder_initializers, _placeholder_extraInitializers);
        __esDecorate(_classThis, null, _hint_decorators, { kind: "accessor", name: "hint", static: false, private: false, access: { has: obj => "hint" in obj, get: obj => obj.hint, set: (obj, value) => { obj.hint = value; } }, metadata: _metadata }, _hint_initializers, _hint_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _invalid_decorators, { kind: "accessor", name: "invalid", static: false, private: false, access: { has: obj => "invalid" in obj, get: obj => obj.invalid, set: (obj, value) => { obj.invalid = value; } }, metadata: _metadata }, _invalid_initializers, _invalid_extraInitializers);
        __esDecorate(_classThis, null, _readonly_decorators, { kind: "accessor", name: "readonly", static: false, private: false, access: { has: obj => "readonly" in obj, get: obj => obj.readonly, set: (obj, value) => { obj.readonly = value; } }, metadata: _metadata }, _readonly_initializers, _readonly_extraInitializers);
        __esDecorate(_classThis, null, _errorMessage_decorators, { kind: "accessor", name: "errorMessage", static: false, private: false, access: { has: obj => "errorMessage" in obj, get: obj => obj.errorMessage, set: (obj, value) => { obj.errorMessage = value; } }, metadata: _metadata }, _errorMessage_initializers, _errorMessage_extraInitializers);
        __esDecorate(_classThis, null, _selectedDate_decorators, { kind: "accessor", name: "selectedDate", static: false, private: false, access: { has: obj => "selectedDate" in obj, get: obj => obj.selectedDate, set: (obj, value) => { obj.selectedDate = value; } }, metadata: _metadata }, _selectedDate_initializers, _selectedDate_extraInitializers);
        __esDecorate(_classThis, null, _locale_decorators, { kind: "accessor", name: "locale", static: false, private: false, access: { has: obj => "locale" in obj, get: obj => obj.locale, set: (obj, value) => { obj.locale = value; } }, metadata: _metadata }, _locale_initializers, _locale_extraInitializers);
        __esDecorate(_classThis, null, __internalValue_decorators, { kind: "accessor", name: "_internalValue", static: false, private: false, access: { has: obj => "_internalValue" in obj, get: obj => obj._internalValue, set: (obj, value) => { obj._internalValue = value; } }, metadata: _metadata }, __internalValue_initializers, __internalValue_extraInitializers);
        __esDecorate(_classThis, null, _currentDay_decorators, { kind: "accessor", name: "currentDay", static: false, private: false, access: { has: obj => "currentDay" in obj, get: obj => obj.currentDay, set: (obj, value) => { obj.currentDay = value; } }, metadata: _metadata }, _currentDay_initializers, _currentDay_extraInitializers);
        __esDecorate(_classThis, null, _hasClear_decorators, { kind: "accessor", name: "hasClear", static: false, private: false, access: { has: obj => "hasClear" in obj, get: obj => obj.hasClear, set: (obj, value) => { obj.hasClear = value; } }, metadata: _metadata }, _hasClear_initializers, _hasClear_extraInitializers);
        __esDecorate(_classThis, null, __contextMenu_decorators, { kind: "accessor", name: "_contextMenu", static: false, private: false, access: { has: obj => "_contextMenu" in obj, get: obj => obj._contextMenu, set: (obj, value) => { obj._contextMenu = value; } }, metadata: _metadata }, __contextMenu_initializers, __contextMenu_extraInitializers);
        __esDecorate(_classThis, null, __inputDate_decorators, { kind: "accessor", name: "_inputDate", static: false, private: false, access: { has: obj => "_inputDate" in obj, get: obj => obj._inputDate, set: (obj, value) => { obj._inputDate = value; } }, metadata: _metadata }, __inputDate_initializers, __inputDate_extraInitializers);
        __esDecorate(_classThis, null, __dateEntryInput_decorators, { kind: "accessor", name: "_dateEntryInput", static: false, private: false, access: { has: obj => "_dateEntryInput" in obj, get: obj => obj._dateEntryInput, set: (obj, value) => { obj._dateEntryInput = value; } }, metadata: _metadata }, __dateEntryInput_initializers, __dateEntryInput_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsDatePicker = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.CHANGE_EVENT = 'sds.date-picker.changed';
    _classThis.NATIVE_CHANGE_EVENT = 'change';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsDatePicker = _classThis;
})();
export { SdsDatePicker };
